import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './orderHistory.css'

const TabsHeader = ({ tabIndex, handleTabChange, handleBackNav }) => (
  <div className="d-flex align-items-center mb-xl-4 me-xxl-4 col-xl-12 col-xxl-5 w-100">
    <button
      onClick={handleBackNav}
      className="btn d-flex align-items-center bg-transparent border-0"
    >
      <ArrowBackIcon className="me-2" />
    </button>
    <div className="custom-tabs w-100">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label="Quote History" value={0} />
            <Tab label="Purchase Order History" value={1} />
          </Tabs>
        </Box>
      </Box>
    </div>
  </div>
);

export default TabsHeader;
